<app-dialog 
  [(visible)]="visible" 
  [modal]="true" 
  [width]="'450px'" 
  [dismissableMask]="false" 
  [closable]="true"
  [showFooter]="false" 
  [showHeader]="true"
  [header]="title"
  (visibleChange)="visibleChange.emit($event)">
  
  <div class="confirmation-modal-content">
    <div class="confirmation-message">
      <i class="pi pi-question-circle" style="font-size: 3rem; color: var(--primary-color); margin-right: 1rem;"></i>
      <span>{{ message }}</span>
    </div>
    
    <div class="confirmation-actions">
      <p-button
        [label]="cancelLabel | translate"
        icon="pi pi-times"
        (onClick)="closeModal()"
        [styleClass]="cancelButtonClass">
      </p-button>
      <p-button
        [label]="confirmLabel | translate"
        icon="pi pi-check"
        (onClick)="onConfirm()"
        [styleClass]="confirmButtonClass">
      </p-button>
    </div>
  </div>
</app-dialog>

